import React, { useState,useEffect } from "react";
import { useMutation } from "react-query";
import { Link } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { sendForm } from "../../Apis";
import Error from "../../Components/Modal.Error";
import Success from "../../Components/Modal.Success";
import { userState } from "../../Recoil/Auth";
import AOS from 'aos';
import 'aos/dist/aos.css'




export default function Contact() {
  const user = useRecoilValue(userState);
  const [data, setData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    userId: user._id,
  });


  useEffect(() => {
    AOS.init({disable: 'mobile',mirror:true});
    AOS.refresh();
  }, []);


  const { mutate, isLoading } = useMutation((data) => sendForm(data), {
    onSuccess: (res) => {
      Success(res?.data?.message);
      setData({
        name: "",
        email: "",
        subject: "",
        message: "",
        userId: user._id,
      });
    },
    onError: (err) => Error(err?.response?.data?.message),
  });

  return (
    <>
      <section className="bg-about">
      <img
            style={{
              width: "400px",
              position: "absolute",
              left: 0,
              bottom: 0,
              zIndex: 1,
              opacity: 0.8,
            }}
            src="images/bannerLeft.png"
            alt=""
            className="img-fluid"
          />

          <img
            style={{
              width: "400px",
              position: "absolute",
              right: 0,
              top: 0,
              zIndex: 1,
              opacity: 0.8,
            }}
            src="images/bannerRight22.png"
            alt=""
            className="img-fluid"
          />
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
            <div style={{zIndex: 2}} data-aos="fade-up"
                 data-aos-easing="ease-in-sine">
              <h1 className="bannerHeading2">Contact Us</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="p-55-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
            <div style={{zIndex: 2}} data-aos="fade-up"
                data-aos-delay="200" data-aos-easing="ease-in-sine">
              <h1 className="ff-thunder fc-purple">
                CONTACT US FOR BEST SERVICE
              </h1>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="contactForm">
              <div style={{zIndex: 2}} data-aos="fade-up"
                data-aos-delay="400" data-aos-easing="ease-in-sine">
                <form>
                  <div className="form-row">
                    <div className="col-lg-6 col-sm-12">
                      <i className="far fa-user" />
                      <input
                        type="text"
                        className="form-control contactInput mt-30"
                        name
                        placeholder="Full Name"
                        value={data?.name}
                        onChange={(e) =>
                          setData({ ...data, name: e.target.value })
                        }
                      />
                    </div>
                    <div className="col-lg-6 col-sm-12">
                      <i className="far fa-envelope" />
                      <input
                        type="text"
                        className="form-control contactInput mt-30"
                        name
                        placeholder="Email Address"
                        value={data?.email}
                        onChange={(e) =>
                          setData({ ...data, email: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-lg-12 col-sm-12">
                      <i className="fas fa-clipboard-list" />
                      <input
                        type="text"
                        className="form-control contactInput mt-30"
                        name
                        placeholder="Enter Subject"
                        value={data?.subject}
                        onChange={(e) =>
                          setData({
                            ...data,
                            subject: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-lg-12 col-sm-12">
                      <i className="far fa-envelope" />
                      <textarea
                        rows={6}
                        className="form-control contactInput mt-30"
                        placeholder="Enter Message!"
                        value={data?.message}
                        onChange={(e) =>
                          setData({
                            ...data,
                            message: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-lg-12 col-sm-12 text-center mt-30">
                      <Link
                        to="#"
                        className="btn-orange"
                        onClick={() => mutate(data)}
                      >
                        SEND MESSAGE
                      </Link>
                    </div>
                  </div>
                </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
